import { render } from "./ComfirmLayout.vue?vue&type=template&id=0acd470d"
import script from "./ComfirmLayout.vue?vue&type=script&lang=js"
export * from "./ComfirmLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__